module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "ban-developer"
    }
  }, [_c('div', {
    staticClass: "ban-developer-form"
  }, [(_vm.formData.isBanned) ? _c('label', [_vm._v("Un-Ban this developer?")]) : _vm._e(), _vm._v(" "), (!_vm.formData.isBanned) ? _c('label', [_vm._v("Ban this developer?")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (!_vm.formData.isBanned) ? _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitBan($event)
      }
    }
  }, [_vm._v("Yes, Ban")]) : _vm._e(), _vm._v(" "), (_vm.formData.isBanned) ? _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitUnBan($event)
      }
    }
  }, [_vm._v("Un-Ban")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f80b38c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Developer/Widgets/BanDeveloper.vue
// module id = 860
// module chunks = 2